var _style, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWaveBg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1366 841.89",
    style: {
      enableBackground: "new 0 0 1366 841.89"
    },
    xmlSpace: "preserve",
    preserveAspectRatio: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:url(#gradient_01_3_);}\r\n\t.st1{fill:url(#gradient_01-2_1_);}\r\n\t.st2{fill:url(#gradient_01_4_);}\r\n")), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gradient_01_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 386.5853,
    y1: 842.0475,
    x2: 386.5853,
    y2: 840.8195,
    gradientTransform: "matrix(1367.038 0 0 -527.6812 -527793.8125 444332.5938)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#633ca3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#321e52"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "gradient_01_1_",
    className: "st0",
    d: "M337.23,526.68c334.53-8.21,384.57-112.79,816.53-99.42 c82.37,2.55,152.58,15.92,212.24,35.86V0L0,0v488.32C59.93,509.74,163.88,530.93,337.23,526.68z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveBg);
export default __webpack_public_path__ + "static/media/wave-bg.4f403c44ef4c33382d68b111c4213680.svg";
export { ForwardRef as ReactComponent };